import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from 'domains/merchant-inbound-item/molecules/table-column'

const propTypes = {
  data              : PropTypes.array,
  pagination        : PropTypes.object,
  onFetchData       : PropTypes.func,
  isLoading         : PropTypes.bool,
  hiddenColumns     : PropTypes.arrayOf(PropTypes.string),
  curateButtonProps : PropTypes.shape({
    buttonCurateText       : PropTypes.string,
    buttonCurateColour     : PropTypes.string,
    onButtonCurateClick    : PropTypes.func,
    isButtonCurateDisabled : PropTypes.func
  }),
  printSKUButtonProps: PropTypes.shape({
    buttonPrintText    : PropTypes.string,
    buttonPrintColour  : PropTypes.string,
    onButtonPrintClick : PropTypes.func
  })
}

const defaultProps = {
  hiddenColumns     : [],
  isLoading         : false,
  curateButtonProps : {
    buttonCurateText       : 'Process',
    buttonCurateColour     : 'default',
    onButtonCurateClick    : () => {},
    isButtonCurateDisabled : () => {}
  },
  printSKUButtonProps: {
    buttonPrintText    : 'Process',
    buttonPrintColour  : 'default',
    onButtonPrintClick : () => {}
  }
}

/**
 * Table to display specific Merchant Inbound Item
 * @param {Array<Object>} data - array of merchant_inbound_item objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const MerchantInboundItemTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  curateButtonProps,
  printSKUButtonProps,
  isLoading
}) => {
  const { buttonCurateText, buttonCurateColour, onButtonCurateClick, isButtonCurateDisabled } = curateButtonProps
  const { buttonPrintText, buttonPrintColour, onButtonPrintClick }                            = printSKUButtonProps

  const columns = useMemo(() => tableColumns({
    buttonCurateText,
    buttonCurateColour,
    onButtonCurateClick,
    isButtonCurateDisabled,
    buttonPrintText,
    buttonPrintColour,
    onButtonPrintClick
  }),
  [ buttonCurateText, buttonCurateColour, onButtonCurateClick, isButtonCurateDisabled, buttonPrintText, buttonPrintColour, onButtonPrintClick ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

MerchantInboundItemTable.propTypes    = propTypes
MerchantInboundItemTable.defaultProps = defaultProps

export default MerchantInboundItemTable
